import { AdCampaign } from "../AdCampaign/AdCampaign"

export enum AdUnitLocation {
  DesignerProductCatalog = "designer_product_catalog",
  DesignerVendorCatalog = "designer_vendor_catalog",
  DesignerCategoryMenu = "designer_category_menu",
}

export enum AdUnitFormat {
  Content = "content",
}

export enum AdvertisableType {
  Product = "App\\Models\\Product",
  Vendor = "App\\Models\\Vendor",
}

interface AdUnitContent {
  title: string
  tagline: string
  destination_url: string
  cta_text: string
}

interface Taxonomy {
  id: string
  name: string
  type: string
  path: string
}

export interface AdUnit {
  id: number
  ad_campaign_id: number
  ad_campaign?: AdCampaign
  location: AdUnitLocation
  format: AdUnitFormat
  taxonomy_id?: number
  taxonomy?: Taxonomy
  image?: {
    url: string
  }
  advertisable_id?: string
  advertisable_type?: AdvertisableType
  advertisable?: unknown
  content?: AdUnitContent
  interactions_count?: number
  views_count?: number
  clicks_count?: number
}
